import { gql } from '@apollo/client'
// This is the same for public and resigned public profiles
export default gql`
  fragment BankAccount on InternationalBankAccount {
    country
    bankName
    accountName
    iban
    bicSwift
    accountNumber
    type
    agency
    bankSortCode
    bankCode
  }
`
